import React from 'react'

export default function Redirect_member_list() {
  return (
    <div>
      
    </div>
  )
}
